import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';


@Component({
  selector: 'app-sanitization',
  templateUrl: './sanitization.component.html',
  styleUrls: ['./sanitization.component.scss']
})
export class SanitizationComponent extends BaseComponent implements OnInit {

  blackground:boolean = false;

  ngOnInit(): void {
  	var that = this;

  	// setTimeout(function(){
  	// 	that.blackground = true;
  	// }, 3000);
  }

}
